import React from 'react';
import SeatMap from '@weezevent/throne';
import LoadingCard from '../../../../../../components/loadingCard';
import SelectedSeatsModal from './SelectedSeatsModal';
import css from './seatmap.module.css';

export default function Map({
    form,
    sync,
    zone,
    seats,
    setForm,
    chartId,
    synczones,
    categories,
    contingents,
    inputError,
    inventories,
    organization,
    loadingSeats,
    loadingzones,
    setFormObject,
    inputValidity,
    inventoriesOptions
}) {
    const handleSelect = React.useCallback(
        s => {
            setFormObject(
                {
                    selectedSeats: [s],
                    selectedCategory: categories.find(cat => s.category === cat?.uuid)?.uuid || '',
                    selectedContingent: contingents.find(cont => s.contingent === cont?.uuid)?.uuid || ''
                },
                true
            );
        },
        [setFormObject, categories, contingents]
    );

    const handleGroupSelect = React.useCallback(
        s => {
            setForm('selectedSeats', s);
        },
        [setForm]
    );

    const modalToggle = React.useMemo(() => {
        return form.selectedSeats.length > 0;
    }, [form.selectedSeats]);

    return (
        <LoadingCard loading={form.inventory?.uuid ? loadingSeats || loadingzones : loadingzones}>
            {modalToggle && (
                <SelectedSeatsModal
                    form={form}
                    sync={sync}
                    zone={zone}
                    chartId={chartId}
                    setForm={setForm}
                    synczones={synczones}
                    inputError={inputError}
                    inventories={inventories}
                    organization={organization}
                    inputValidity={inputValidity}
                    setFormObject={setFormObject}
                    inventoriesOptions={inventoriesOptions}
                    categories={categories?.filter(cat => !cat.general_admission)}
                    contingents={contingents}
                />
            )}
            <div className={css['seat-map-container']}>
                <SeatStyles
                    seats={form?.inventory !== 'default' ? seats : zone?.seats}
                    selectedSeats={form.selectedSeats}
                    type={form.type}
                    categories={categories}
                    contingents={contingents}
                />
                <SeatMap
                    backButton={true}
                    showPopup={!form.selectedSeats?.length}
                    currentInventory={form.inventory}
                    zone={zone}
                    onSeatsSelected={handleGroupSelect}
                    onSeatClicked={handleSelect}
                    mapOptions={{
                        showRowNumbers: true,
                        zoomControls: true
                    }}
                />
            </div>
        </LoadingCard>
    );
}

export function SeatStyles({ seats, selectedSeats, type, categories, contingents }) {
    let seat_styles = seats.map(seat => {
        const seat_color = React.useMemo(() => {
            if (type === 'categories') {
                return categories.find(cat => cat.uuid === seat.category)?.color;
            } else {
                return contingents.find(cat => cat.uuid === seat.contingent)?.color;
            }
        }, [type, seats, categories, contingents, selectedSeats]);
        let color = seat_color || '#878c9b';
        let stroke = seat.booking_state === 'LOCKED_FOR_SOCIAL_DISTANCING' && seat_color;

        if (seat.booking_state === 'LOCKED_FOR_SOCIAL_DISTANCING') {
            color = '#FFF';
        }
        return `td[data-seat-id="${seat.uuid}"] svg path {
                fill: ${color};
            stroke: ${stroke};
		}

            td[data-seat-id="${seat.uuid}"] {
                cursor: ${color};
		}
            td[data-seat-id="${seat.uuid}"]:hover svg path {
                fill: ${color} !important;
		}`;
    });

    const styles = selectedSeats?.map(seat => {
        return `
            td[data-seat-id="${seat.uuid}"] svg path {
                stroke: ${'#404040'};
			}
            `;
    });
    return <style>{seat_styles.concat(styles)}</style>;
}
